import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import PropTypes from "prop-types";

const TextArea = ({ onBlur, type, style, label, placeholder, value, onChange, error, name, containerStyles, ...rest }) => {
    return (
        <div style={containerStyles}>
            {label && <p style={{ fontWeight: 500 }}>{label}</p>}
            <InputTextarea {...rest} type={type} name={name} onBlur={onBlur} style={style} placeholder={placeholder} value={value} onChange={onChange} />
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
};

export default TextArea;

TextArea.propTypes = {
    onBlur: PropTypes.func,
    type: PropTypes.string,
    style: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.string,
    name: PropTypes.string,
};
